import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Button } from './components/ui/button';
import { Toaster } from './components/ui/sonner';
import { TooltipProvider } from './components/ui/tooltip';
import AppHeader from './components/AppHeader';
import Login from './pages/Login';
import AdminUsers from './pages/AdminUsers';
import AdminRoles from './pages/AdminRoles';
import Packshots from './pages/Packshots';
import PackshotBatch from './pages/PackshotBatch';
import ProtectedRoute from './components/ProtectedRoute';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AcceptInvite from './pages/AcceptInvite';
import { fetchSession, hasPermission } from './lib/session';
import AmbientOrb from './components/AmbientOrb';
import { ShotDefaultsProvider } from './components/packshots/ModelsDialog';

function Home() {
  const [redirect, setRedirect] = React.useState(false);

  React.useEffect(() => {
    void (async () => {
      const session = await fetchSession();
      if (hasPermission(session, 'packshots.read')) setRedirect(true);
    })();
  }, []);

  if (redirect) return <Navigate to="/packshots" replace />;

  return (
    <div className="app-shell">
      <AppHeader />
      <main className="flex flex-1 flex-col items-center justify-center p-6">
        <img src="/favicon.ico" className="w-24 h-24 mb-6" alt="bbpackshots logo" />
        <h1 className="text-4xl font-bold mb-4">bbpackshots</h1>
        <p className="text-muted-foreground mb-6">Full-stack Express TypeScript + React + shadcn/ui</p>
        <Button asChild>
          <a href="https://reactjs.org" target="_blank" rel="noopener noreferrer">Learn React</a>
        </Button>
      </main>
    </div>
  );
}

function AuthOrLogin() {
  const [isAuthed, setIsAuthed] = React.useState<boolean | null>(null);
  React.useEffect(() => {
    (async () => {
      try {
        const res = await fetch('/auth/me');
        setIsAuthed(res.ok);
      } catch {
        setIsAuthed(false);
      }
    })();
  }, []);
  if (isAuthed === null) return <div className="p-4 text-center text-sm text-muted-foreground">Loading...</div>;
  return isAuthed ? <Navigate to="/home" replace /> : <Login />;
}

export default function App() {
  return (
    <TooltipProvider>
      <AmbientOrb />
      <ShotDefaultsProvider>
      <div className="relative z-10">
      <Routes>
        <Route path="/" element={<AuthOrLogin />} />
        <Route path="/home" element={<Home />} />
        <Route path="/forgot" element={<ForgotPassword />} />
        <Route path="/reset" element={<ResetPassword />} />
        <Route path="/invite" element={<AcceptInvite />} />
        <Route path="/packshots" element={<ProtectedRoute permissions={['packshots.read']}><Packshots /></ProtectedRoute>} />
        <Route path="/packshots/batches/:id" element={<ProtectedRoute permissions={['packshots.read']}><PackshotBatch /></ProtectedRoute>} />
        <Route path="/admin/users" element={<ProtectedRoute permissions={['users.read']}><AdminUsers /></ProtectedRoute>} />
        <Route path="/admin/roles" element={<ProtectedRoute permissions={['roles.read']}><AdminRoles /></ProtectedRoute>} />
      </Routes>
      </div>
      </ShotDefaultsProvider>
      <Toaster />
    </TooltipProvider>
  );
}
